import { render, staticRenderFns } from "./BookingFinance.vue?vue&type=template&id=5d96d9cc"
import script from "./BookingFinance.vue?vue&type=script&lang=ts"
export * from "./BookingFinance.vue?vue&type=script&lang=ts"
import style0 from "./BookingFinance.vue?vue&type=style&index=0&id=5d96d9cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports